import { useState } from 'react';
import * as Yup from 'yup';
import { FormattedMessage } from 'react-intl';
import { Formik, Form as FormikForm } from 'formik';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';

import Text from '../../components/Text';
import TextInput from '../../components/TextInput';
import Button from '../../components/Button';
import useValidationMessages from '../../helpers/useValidationMessages';
import ErrorBox from '../../components/ErrorBox';
import CenteredPage from '../../containers/CenteredPage';
import Box from '../../components/layout/Box';

const ForgotPassword = () => {
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState();

  const navigate = useNavigate();

  const { invalidEmailAddress, required } = useValidationMessages();

  const initialValues = {
    email: '',
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email(invalidEmailAddress).required(required),
  });

  const handleSignUp = async ({ email }) => {
    setLoading(true);
    setError(null);

    // Send confirmation code to user's email
    Auth.forgotPassword(email)
      .then(() => {
        // send to change password page
        navigate('/reset-password', { state: { email } });
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setError(err.code);
      });
  };

  const getErrorMessage = () => {
    if (error === 'UserNotFoundException') {
      return <FormattedMessage defaultMessage="Användaren hittades inte." />;
    }

    return <FormattedMessage defaultMessage="Okänt fel, försök gärna igen." />;
  };

  return (
    <CenteredPage
      className="pt-5"
      style={{
        maxWidth: 520,
      }}
    >
      <Box className="w-100 flex-column">
        <h2>
          <FormattedMessage defaultMessage="Glömt ditt lösenord?" />
        </h2>

        <Text variant="body" className="mb-3 mt-1">
          <FormattedMessage defaultMessage="Ingen fara, vi skickar instruktioner om hur du återställer ditt lösenord." />
        </Text>

        <Formik
          onSubmit={(values) => {
            handleSignUp(values);
          }}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          {({ values, errors, handleChange, handleBlur, submitCount }) => {
            const showErrors = submitCount > 0;

            return (
              <FormikForm>
                <TextInput
                  type="text"
                  name="email"
                  onChange={handleChange('email')}
                  onBlur={handleBlur}
                  value={values.email}
                  error={showErrors && errors.email}
                  placeholder={
                    <FormattedMessage defaultMessage="E-postadress" />
                  }
                />

                {error && <ErrorBox text={getErrorMessage()} />}

                <div className="d-flex w-100 justify-content-end">
                  <Button type="submit" isLoading={isLoading}>
                    <FormattedMessage defaultMessage="Skicka" />
                  </Button>
                </div>
              </FormikForm>
            );
          }}
        </Formik>
      </Box>
    </CenteredPage>
  );
};

export default ForgotPassword;
